<template>
    <div class="mitglieder-multi-select">
        <CheckboxSelect
            :id="id"
            :options="options"
            :size="size"
            :selectSize="5"
            :isBusy="busy"
            :sortActive="true"
            :disabled="disabled"
            :value="localValue"
            @input="input"
        />
    </div>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import CheckboxSelect from "@/components/CheckboxSelect/CheckboxSelect";

const MitgliederApi = ApiFactory.get("mitglieder");
const StatusApi = ApiFactory.get("status");

import "./MitgliederMultiSelect.scss";

export default {
    name: "MitgliederMultiSelect",
    props: {
        id: String,
        value: {
            type: Array,
            default: () => []
        },
        size: String,
        chorExclusive: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    components: {
        CheckboxSelect
    },
    data() {
        return {
            busy: false,
            data: [],
            options: [],
            localValue: this.value ? this.value : []
        };
    },
    created() {
        this.fetch();
    },
    watch: {
        value: {
            handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.localValue = newValue;
                }
            }
        }
    },
    methods: {
        async fetch() {
            this.busy = true;
            if (this.chorExclusive) {
                const responseStatus = await StatusApi.getChor();
                if (responseStatus.ok && responseStatus.json.collection) {
                    const statusFilter = responseStatus.json.collection.map(
                        status => status.value
                    );
                    const response = await MitgliederApi.get({
                        fields: ["id", "vorname", "name"],
                        order: "name",
                        sort: "asc",
                        limit: -1,
                        filter: {
                            status: statusFilter
                        }
                    });
                    if (response.ok) {
                        const items = response.json.collection;
                        this.options = items.map(item => {
                            return {
                                value: item.id,
                                text:
                                    item.name +
                                    ", " +
                                    item.vorname +
                                    " (" +
                                    item.id +
                                    ")"
                            };
                        });
                        this.data = items;
                    }
                }
            } else {
                const response = await MitgliederApi.get({
                    fields: ["id", "vorname", "name", "status"],
                    order: "name",
                    sort: "asc",
                    limit: -1
                });
                if (response.ok) {
                    const items = response.json.collection;
                    this.options = items.map(item => {
                        return {
                            value: item.id,
                            text:
                                item.name +
                                ", " +
                                item.vorname +
                                " (" +
                                item.id +
                                ")"
                        };
                    });
                    this.data = items;
                }
            }
            this.busy = false;
        },
        input(value) {
            this.$emit("input", value);
        }
    }
};
</script>
